import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import ACCESS from 'utils/Access'
import StatusPopOver from './StatusPopOver'

import POWER_ICON from '!svg-inline?removeTags=true!images/icons/bolt.svg'

import './style.styl'

class UpgradeStatus extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayMenu: false,
      isOpen: false,
      flyoutPosition: 0,
    }
  }

  toggleClick = () => {
    const wrapperRect = this.wrapperRef.getBoundingClientRect()

    this.setState(prevState => ({
      displayMenu: !prevState.displayMenu,
      flyoutPosition: window.innerHeight - wrapperRect.bottom,
    }))
  }

  handleClose = () => {
    this.setState({ isOpen: false })
  }

  handleOpen = () => {
    this.setState({ isOpen: true })
  }

  togglePopover = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  render() {
    if (ACCESS.hasGates('premium_drift')) return null

    return (
      <div className="upgrade-status-bar" ref={ref => this.wrapperRef = ref}>
        <span onClick={this.toggleClick}>
          <Icon src={POWER_ICON} />
        </span>
        {this.state.displayMenu && (
          <div style={{ position: 'fixed', bottom: this.state.flyoutPosition }}>
            <StatusPopOver onClickOutside={this.toggleClick} />
          </div>
        )}
      </div>
    )
  }
}

export default UpgradeStatus



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/UpgradeStatus/index.js